/** @copyright (c) Viewpost. All Rights Reserved. See LICENSE for more details. */

const canUseDOM = !!(
  typeof window !== 'undefined'
  && window.document
  && window.document.createElement
);

export default canUseDOM;